var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{staticClass:"fas fa-check-circle",class:[_vm.stock ? 'product__status__icon' : 'product__status__info']}),_vm._v(" "),_c('span',{staticClass:"product__status__info"},[_vm._v(_vm._s(_vm.stockText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }